module.exports = __webpack_public_path__ + "img/Metastasis-BRCA_10X_WTA.631b454f.png";